import { cart, pubsub } from '@services';
import { parseHTML } from '@utils';

class CartItemCount extends HTMLElement {
  #unsubscribers = [];

  static {
    cart.sections.push('fetch-cart-item-count');
  }

  connectedCallback() {
    this.#unsubscribers.push(
      ...['cart:add', 'cart:update', 'cart:change'].map((event) =>
        pubsub.subscribe(event, ({ sections }) => this.#renderSection(sections))
      )
    );
  }

  disconnectedCallback() {
    this.#unsubscribers.forEach((unsubscribe) => unsubscribe());
  }

  #renderSection(sections) {
    const html = parseHTML(sections['fetch-cart-item-count']);
    const target = html?.querySelector('cart-item-count');
    if (target) this.replaceWith(target);
  }
}

if (!customElements.get('cart-item-count')) {
  customElements.define('cart-item-count', CartItemCount);
}
